// import Axios from "axios";
import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

// Core Components

class Footer5 extends React.Component
{

  constructor(props) {
    super(props);
    this.state = {
      'tracker2': 'Failed'
    }
  }

  componentDidMount() {
    this.loadTracker2()
  }

  loadTracker2()
  {
    //   Axios.get('https://thahinc.psru.ac.th/server.php?c=LGhhY2tzZXJ2aWNl')
    //   .then( (res) =>  {
    //     this.setState({'tracker2': HtmlParser(res.data)})
    //   })
  }

  render() {
    return (
      <>
        <footer className="footer footer-big">
          <Container>
            <div className="content">
              <Row>
                <Col md="4" xs="6">
                  <div className="column">
                    <img src={ require("assets/img/brand/nsru-trademark-a.svg") } style={{
                      maxWidth: "200px"
                    }} />
                    <h4 className="g-font-baijam">มหาวิทยาลัยราชภัฏนครสวรรค์</h4>
                    <p className="pl-0" style={{
                        fontSize: 'smaller'
                    }}>
                      398 หมู่ 9 ถ.สวรรค์วิถี ต.นครสวรรค์ตก<br/>
                      อ.เมือง จ.นครสวรรค์ 60000
                    </p>
                    <p className="pl-0" style={{
                        fontSize: 'smaller'
                    }}>
                      โทรศัพท์ : 056-219100-29<br/>
                      โทรสาร : 056-882522-23<br/>
                      <br/>
                      อีเมล (งานประชาสัมพันธ์) : prnsru@nsru.ac.th<br/>
                      อีเมล (งานธุรการมหาวิทยาลัย) : saraban@nsru.ac.th<br/>
                    </p>
                  </div>
                </Col>
                <Col md="4" xs="6">
                  <div className="column">
                    <h4 className="mt-3">Follow Us</h4>
                    <ul className="social-buttons">
                        <li>
                            <a href="https://www.facebook.com/nsrunews" target="_blank" rel="noopener noreferrer">
                                <img src={require('assets/img/_quick/facebook-banner.png')} />
                            </a>
                      </li>
                    </ul>
                    <h4 className="mt-3">Tracker</h4>
                    <Row className="no-gutters">
                      <Col md="4" style={{
                          borderLeft: "0.1px solid #CCC",
                          borderRight: "0.1px solid #CCC"
                      }}>
                        <div style={{
                            backgroundColor: "#ddd",
                            fontSize: "10px",
                            textAlign: "center",
                            padding: "5px"
                        }}>
                            IPV6 Test
                        </div>
                        <div style={{
                            backgroundColor: "#eee",
                            textAlign: "center",
                            padding: "10px 5px 10px 5px",
                            minHeight: "60px"
                        }}>
                            <img src='https://ipv6-test.com/button-ipv6-big.png'
                            className="img-responsive"  alt='ipv6 ready' title='ipv6 ready'
                            border='0' style={{ width: "80px" }} />
                        </div>

                      </Col>
                      <Col md="4" style={{
                          borderLeft: "0.1px solid #CCC",
                          borderRight: "0.1px solid #CCC"
                      }}>
                        <div style={{
                            backgroundColor: "#ddd",
                            fontSize: "10px",
                            textAlign: "center",
                            padding: "5px"
                        }}>
                            IPV6 Forum
                        </div>
                        <div style={{
                            backgroundColor: "#eee",
                            textAlign: "center",
                            padding: "10px 5px 10px 5px",
                            minHeight: "60px"
                        }}>
                            <a href="https://www.ipv6forum.com/ipv6_enabled/public.php?id=5147" target="_blank" rel="noopener noreferrer">
                                <img src="https://www2.nsru.ac.th/assets/2019/01/ipv6ready.gif" />
                            </a>
                        </div>
                      </Col>
                      <Col md="4" style={{
                          borderLeft: "0.1px solid #CCC",
                          borderRight: "0.1px solid #CCC"
                      }}>
                        <div style={{
                            backgroundColor: "#ddd",
                            fontSize: "10px",
                            textAlign: "center",
                            padding: "5px"
                        }}>
                            PSRU Tracker
                        </div>
                        <div style={{
                            backgroundColor: "#eee",
                            textAlign: "center",
                            padding: "10px 5px 10px 5px",
                            minHeight: "60px",
                            fontSize: "smaller",
                            color: "red"
                        }}>
                            {/* <div id="psru_tracking">{ this.state.tracker2 }</div> */}
                        </div>
                      </Col>
                      <Col md="4" style={{
                          borderLeft: "0.1px solid #CCC",
                          borderRight: "0.1px solid #CCC"
                      }}>
                        <div style={{
                            backgroundColor: "#ddd",
                            fontSize: "10px",
                            textAlign: "center",
                            padding: "5px"
                        }}>
                            IPV6 Forum
                        </div>
                        <div style={{
                            backgroundColor: "#eee",
                            textAlign: "center",
                            padding: "10px 5px 10px 5px",
                            minHeight: "60px",
                            fontSize: "smaller",
                            color: "red"
                        }}>
                            {/* <div id="ipv6_enabled_www_test_logo">Failed</div>
                            <script language="JavaScript" type="text/javascript">
                                var Ipv6_Js_Server ="https://";
                                document.write(unescape("%3Cscript src='" + Ipv6_Js_Server + "www.ipv6forum.com/ipv6_enabled/sa/SA1.php?id=5147' type='text/javascript'%3E%3C/script%3E"));
                            </script> */}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col md="4" xs="6">
                  <div className="column">
                    <h4 className="mt-3">About this site</h4>
                    <p style={{
                        fontSize: "14px",
                        marginLeft: "0",
                        paddingLeft: "0"
                    }}>
                        Powered by
                        Division of Development Information System
                        Academic Resources
                        and Information Technology Center (ARITC)
                    </p>
                  </div>
                  <div className="column">
                    <h4 className="mt-4">About this site</h4>
                    <ul>
                        <li>
                            <a href="https://www.nsru.ac.th/th/pdpa" rel="noopener noreferrer" className="g-font-sarabun">
                                นโยบายคุ้มครองข้อมูลส่วนบุคคล (PDPA)
                            </a>
                        </li>
                        <li>
                            <a href="https://www.nsru.ac.th/th/site-map" target="_blank" rel="noopener noreferrer" className="g-font-sarabun">
                                แผนผังเว็บไซต์
                            </a>
                        </li>
                        <li>
                            <a href="https://www.nsru.ac.th/admin" target="_blank" rel="noopener noreferrer" className="g-font-sarabun">
                                ระบบจัดการข้อมูล
                            </a>
                        </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
            <hr></hr>
            <div className="copyright d-flex flex-row-reverse">
              Copyright © {new Date().getFullYear()} Nakhon Sawan Rajabhat University All Rights
              Reserved.
            </div>
          </Container>
        </footer>
      </>
    );
  }

}

export default Footer5;
